const getMediaFileName = (key?: string | null): string => {
  if (!key) {
    return ""
  }

  return key.replace(/[\w]+\/?[\d]+-/, "")
}

export default getMediaFileName
